import {config} from '../../config'

export const hideElementsDependedOfWL = () => {
  switch (config.key) {
    case 'lydian':
      return true
    default: return false
  }
}
